import * as Yup from 'yup';

export const RatedDriverSortBySchema = Yup.object().shape({
  sortBy: Yup.string(),
});

export type RatedDriverSortByDataType = Yup.InferType<
  typeof RatedDriverSortBySchema
>;

type InitialValues = {
  sortBy: string;
};

export const RatedDriverSortBySchemaInitialValues: InitialValues = {
  sortBy: 'Default',
};

export interface IRatedDriverSortByResponse {}

export interface IRatedDriverSortByRequest {
  sortBy: string;
}
